<template>
  <div class="container py-5">
    <JobDescriptionHeader
        title="شرایط احراز شغل"
        description="در این بخش، الزامات و شرایط لازم برای احراز شغل به‌طور دقیق بررسی می‌شود تا فرد مناسب با نیازهای شغلی منطبق شود."
    />
    <div class="row">
      <div class="col-md-6">
        <GenderSection/>
      </div>
      <div class="col-md-6">
        <AgeRangeSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <CoursesSection/>
      </div>
      <div class="col-md-6">
        <RelatedSoftwareSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <StudyFieldsSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <LanguagesSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <ExperienceYearsSection class="pb-3"/>
      </div>
      <div class="col-md-6">
        <CareerPathSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <RequiredEquipmentsSection/>
      </div>
      <div class="col-md-6">
        <PhysicalTraitsSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <WorkTimeSection/>
      </div>
      <div class="col-md-6">
        <WorkAreaSection/>
      </div>
    </div>

    <NavigationButtons @next="next" @prev="$emit('prev')"/>
  </div>
</template>

<script>
import NavigationButtons from "@/components/JobDescription/GeneralComponents/NavigationButtons.vue";
import JobDescriptionHeader from "@/components/JobDescription/GeneralComponents/JobDescriptionHeader.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GenderSection from "@/components/JobDescription/StepTwo/GenderSection.vue";
import AgeRangeSection from "@/components/JobDescription/StepTwo/AgeRangeSection.vue";
import LanguagesSection from "@/components/JobDescription/StepTwo/LanguagesSection.vue";
import RelatedSoftwareSection from "@/components/JobDescription/StepTwo/RelatedSoftwareSection.vue";
import CoursesSection from "@/components/JobDescription/StepTwo/CoursesSection.vue";
import StudyFieldsSection from "@/components/JobDescription/StepTwo/StudyFieldsSection.vue";
import ExperienceYearsSection from "@/components/JobDescription/StepTwo/ExperienceYearsSection.vue";
import CareerPathSection from "@/components/JobDescription/StepTwo/CareerPathSection.vue";
import RequiredEquipmentsSection from "@/components/JobDescription/StepTwo/RequiredEquipmentsSection.vue";
import PhysicalTraitsSection from "@/components/JobDescription/StepTwo/PhysicalTraitsSection.vue";
import WorkTimeSection from "@/components/JobDescription/StepTwo/WorkTimeSection.vue";
import WorkAreaSection from "@/components/JobDescription/StepTwo/WorkAreaSection.vue";

export default {
  components: {
    WorkAreaSection, WorkTimeSection, PhysicalTraitsSection, RequiredEquipmentsSection, CareerPathSection, ExperienceYearsSection,
    CoursesSection,
    RelatedSoftwareSection,
    LanguagesSection,
    StudyFieldsSection,
    AgeRangeSection,
    GenderSection,
    GeneralTable,
    GeneralModal,
    JobDescriptionHeader,
    NavigationButtons
  },
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/job-qualifications/get-first',
      afterMutation: 'jobQualification/setJobQualification'
    });
  },
  methods: {
    next() {
      this.$store.dispatch('crudActions/create', {
        resourceData: this.$store.state.jobQualification.jobQualification,
        endpoint: '/job-qualifications',
      })

      this.$emit("next");
    },
  },
};
</script>
